module.exports = {
    "oh_url": "https://ophub.litedev.com",
    "ch_url": "https://chs.litedev.com",
    jwtSecret: "fgxzbmvhgkiteqw135rodjdxff+=sdhbkvnxzm+=",
    encryptedKey: "fsfhjkgweer+12fbmvngdvdfr+==",
    "hms_url": "https://hms.litedev.com/",
    socketHub: "https://socketdev.litedev.com",
    "cp_url": "https://cflow.litedev.com"
}



//////////////////
// WEBPACK FOOTER
// ./config/endpoints.js
// module id = VPkb
// module chunks = 27